import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalActions,
  Button,
  Form,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { reduxForm, submit } from 'redux-form';

function CouponToggleConfirmationModal({
  shown,
  couponCode,
  action,
  onClose,
  isLoading,
  handleSubmit,
  dispatch,
}) {
  return (
    <Modal open={shown} onClose={onClose}>
      <ModalHeader>Confirm Coupon Toggle</ModalHeader>
      <ModalContent>
        <p>
          Are you sure to <strong>{action}</strong> coupon
          <span> </span>
          <strong>{couponCode}</strong>?
        </p>
        <Form onSubmit={handleSubmit} />
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose} disabled={isLoading}>
          No
        </Button>
        <Button
          negative
          onClick={() => dispatch(submit('coupon-toggle'))}
          disabled={isLoading}
          loading={isLoading}
        >
          Yes
        </Button>
      </ModalActions>
    </Modal>
  );
}

CouponToggleConfirmationModal.propTypes = {
  shown: PropTypes.bool.isRequired,
  couponCode: PropTypes.string,
  action: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

CouponToggleConfirmationModal.defaultProps = {
  couponCode: null,
  action: null,
};

export default connect()(
  reduxForm({
    form: 'coupon-toggle',
  })(CouponToggleConfirmationModal)
);
